import { Directive, ElementRef, Input, OnChanges, OnInit } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[colorifyDate]',
})
export class ColorifyDateDirective implements OnInit, OnChanges {
  @Input() colorifyDate: any;

  constructor(private el: ElementRef) {}

  colnames = ['deadline', 'nextDueDate', 'endDateTime', 'dueDate'];
  result: number | null | undefined;

  ngOnInit() {
    this.setDateColor(this.colorifyDate);
  }

  ngOnChanges() {
    this.setDateColor(this.colorifyDate);
  }

  private setDateColor(data: any) {
    const colname = data.colname;
    const deadline = data.deadline;
    const milestone = data.milestone;

    if (colname === 'endDateTime') {
      const date = new Date(deadline.replace(/[|]/g, '')).toISOString();
      this.result = this.daysLeft(date);
    } else if (milestone !== '' && colname === 'nextDueDate') {
      this.result = this.daysLeft(this.colorifyDate.milestone);
    } else {
      this.result = this.daysLeft(this.colorifyDate.deadline);
    }

    if (this.result !== null) {
      if (this.colnames.includes(colname)) {
        if (this.result < 0) {
          this.el.nativeElement.classList.add('expired');
        }
        if (this.result === 0) {
          this.el.nativeElement.classList.add('deadline');
        }
      }
    }
  }

  private daysLeft(input: string) {
    if (!input) {
      return null;
    }
    const targetDate = new Date(input);
    const currentDate: any = new Date();
    const oneDay = 1000 * 60 * 60 * 24;
    const firstDate = Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    const secondDate = Date.UTC(targetDate.getFullYear(), targetDate.getMonth(), targetDate.getDate());
    const daysleft = (secondDate - firstDate) / oneDay;

    return daysleft;
  }
}
